module.exports = __webpack_public_path__ + "/img/ZZBT-BwAhum.svg";